import { render, staticRenderFns } from "./UiHighCharts.vue?vue&type=template&id=fb515952&"
import script from "./UiHighCharts.vue?vue&type=script&lang=js&"
export * from "./UiHighCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports